import { isWafDetectEnabled } from "@/libs/rcmTableFieldsFunction";
import enumList from "@/libs/enumList";
import { ipValidate } from "@/api/formValidate";
const countryCode = require("@/data/countryCode.json");
import { getFormOptions } from "@/api/formoptions";

export default function (vm) {
    const dynamicNameOptions = (vm) => {
        const { type } = vm.value;
        const optionsMap = {
            detect: enumList.WAF_DETECT_KEYS.map((item) => ({ label: vm.$t(`wafrules.${item}`), value: item })),
            action: [
                { label: "Allow", value: "00" },
                // { label: "Deny", value: "01" },
                // { label: "Gesture Challenge", value: "03" },
                // { label: "Speed Limit", value: "05" },
                // { label: "Redirect", value: "06" },
                // {
                //     label: "Cookie / JS Challenge",
                //     value: "07",
                // },
                // { label: "Block Period", value: "08" },
                // { label: "Set Request Headers", value: "09" },
                { label: "Set Response Headers", value: "10" },
                { label: "Log Only", value: "11" },
                // { label: "Custom Page", value: "12" },
                // { label: "Origin Policy", value: "13" },
                // { label: "Smart Captcha", value: "14" },
                // { label: "Scroll", value: "15" },
                // { label: "Hotlink", value: "16" },
            ],
        };
        return optionsMap[type] || [];
    };

    return [
        {
            key: "type",
            label: this.$t("intelligentProtectionSettings.wafRule.rules.rule.type"),
            formRender: "FormSelect",
            options: [
                { label: "Detect", value: "detect" },
                { label: "Action", value: "action" },
            ],
            defaultVal: "detect",
            watchField: (value, item) => {
                const defaultValue = value === "detect" ? "wafIp" : "00";
                vm.value.name = defaultValue;
            },
            vShowFieldVal: (item) => 1,
            disabled: () => true,
        },
        {
            key: "name",
            label: this.$t("intelligentProtectionSettings.wafRule.rules.rule.name"),
            formRender: "FormSelect",
            options: dynamicNameOptions(vm),
            defaultVal: "",
            vShowFieldVal: (item) => 1,
            disabled: () => false,
        },
        {
            key: "isPositive",
            label: this.$t("intelligentProtectionSettings.wafRule.rules.rule.isPositive"),
            formRender: "FormSwitch",
            watchField: function (item) {},
            vShowFieldVal: (item) => (vm.formItem.type === "detect" ? true : false),
            extraProps: {
                openText: this.$t("wafrules.match"),
                closeText: this.$t("wafrules.misMatch"),
            },
        },
        {
            key: "ip",
            label: this.$t("wafrules.wafIp"),
            formRender: "FormSelect",
            options: [],
            defaultVal: [],
            multiple: true,
            selectAllowCreate: true,
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafIp" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
                {
                    validator: (rule, value, callback, source, options) => {
                        value.forEach((e, i) => {
                            let index = value.findIndex((x) => x == e);
                            if (index !== i) return callback(new Error(`${vm.$t("rcmtable.duplicate")}${e}`));
                            if (/[\s]/.test(e)) return callback(new Error(`${vm.$t("rcmtable.invalid")}${e}`));
                        });
                        ipValidate("dual-stack-network", value).then((result) => {
                            if (!result.data.success) {
                                return callback(new Error(result.data.message));
                            }
                            callback();
                        });
                    },
                    trigger: "change",
                },
            ],
        },
        {
            key: "uri",
            label: this.$t("wafrules.wafUri"),
            formRender: "WafSegmentBuilder",
            defaultVal: [],
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafUri" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
            extraProps: {
                modalTitle: this.$t(`wafrules.editWafUriModalTitle`),
            },
        },
        {
            key: "headers",
            label: this.$t("wafrules.wafHeaders"),
            formRender: "WafSegmentBuilder",
            defaultVal: [],
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafHeaders" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
            extraProps: {
                mode: "multiple",
                targetFields: ["key", "value"],
                modalTitle: this.$t(`wafrules.editWafHeadersModalTitle`),
            },
        },
        {
            key: "headersExist",
            label: this.$t("wafrules.wafHeaders"),
            formRender: "FormSelect",
            options: [],
            defaultVal: [],
            multiple: true,
            selectAllowCreate: true,
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafHeadersExist" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
        },
        {
            key: "country",
            label: this.$t("wafrules.wafCountry"),
            formRender: "FormSelect",
            options: countryCode,
            defaultVal: [],
            multiple: true,
            selectAllowCreate: false,
            multiSelectWithToolbox: isWafDetectEnabled(vm, "geo"),
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafCountry" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
        },
        {
            key: "isp",
            label: this.$t("wafrules.wafIsp"),
            formRender: "FormSelect",
            options: [],
            defaultVal: [],
            multiple: true,
            selectAllowCreate: true,
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafIsp" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
        },
        {
            key: "proxyType",
            label: this.$t("wafrules.wafProxyType"),
            formRender: "FormSelect",
            options: enumList.WAF_PROXY_TYPE_KEYS.map((item) => ({ label: item, value: item.toLowerCase() })),
            defaultVal: [],
            multiple: true,
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafProxyType" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
        },
        {
            key: "ja3Hashes",
            label: this.$t("wafrules.wafJa3Hashes"),
            formRender: "FormSelect",
            options: [],
            defaultVal: [],
            multiple: true,
            selectAllowCreate: true,
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafJa3Hashes" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
                {
                    validator: (rule, value, callback, source, options) => {
                        const md5Regex = /^[a-f0-9]{32}$/;
                        const checkedValueSet = new Set();
                        for (const e of value) {
                            if (!md5Regex.test(e)) return callback(new Error(`${vm.$t("rcmtable.invalid")}${e}`));
                            if (checkedValueSet.has(e))
                                return callback(new Error(`${vm.$t("rcmtable.duplicate")}${e}`));
                            checkedValueSet.add(e);
                        }
                        callback();
                    },
                    trigger: "change",
                },
            ],
        },
        {
            key: "httpMethod",
            label: this.$t("wafrules.wafHttpMethod"),
            formRender: "FormSelect",
            options: enumList.WAF_HTTP_METHOD_KEYS.map((item) => ({ label: item, value: item.toLowerCase() })),
            defaultVal: [],
            multiple: true,
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafHttpMethod" ? 1 : 0),
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
        },
        {
            key: "rateLimitCount",
            label: this.$t("wafrules.wafRateLimitCount"),
            formRender: "FormInputNumber",
            inputMinNum: 0,
            defaultVal: 0,
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafRateLimit" ? 1 : 0),
            validate: [
                {
                    validator: (rule, value, callback, source, options) => {
                        if (!value) return callback(new Error(vm.$i18n.t("rcmtable.validNumberError")));
                        callback();
                    },
                    trigger: "blur",
                },
            ],
        },
        {
            key: "rateLimitWindow",
            label: this.$t("wafrules.wafRateLimitWindow"),
            formRender: "FormInputNumber",
            inputMinNum: 0,
            defaultVal: 0,
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafRateLimit" ? 1 : 0),
            validate: [
                {
                    validator: (rule, value, callback, source, options) => {
                        if (!value) return callback(new Error(vm.$i18n.t("rcmtable.validNumberError")));
                        callback();
                    },
                    trigger: "blur",
                },
            ],
        },
        {
            key: "rateLimitToken",
            label: this.$t("wafrules.token"),
            formRender: "WafRateLimitTokenForm",
            defaultVal: {
                group: true,
                ruleName: true,
                ip: true,
                host: true,
                uri: false,
                method: false,
                country: false,
                ua: false,
                // customSign: false,
                // customSignValue: "",
            },
            vShowFieldVal: (item) => (item.type === "detect" && item.name == "wafRateLimit" ? 1 : 0),
            extraProps: { showWafRateLimitTokenPreview: false },
        },
        {
            key: "denyHtmlPageName",
            label: this.$t("wafrules.wafDenyHtmlPageName"),
            formRender: "FormSelect",
            defaultVal: "default",
            remoteOptions: async (queryValue, queryParams) => {
                const params = {
                    ...queryParams,
                    groupName: vm.groupName,
                    htmlPageName: `*${queryValue}*`,
                    withDefault: true,
                };
                const queryString = new URLSearchParams(params).toString();
                const result = await getFormOptions(`htmlpagenames?${queryString}`);
                return result.data.options;
            },
            vShowFieldVal: (item) => {
                const nameSet = new Set(["01", "08", "16"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
        },
        {
            key: "denyThenBucket",
            label: this.$t("wafrules.wafIsDenyThenBucket"),
            formRender: "FormSwitch",
            watchField: function (item) {},
            vShowFieldVal: (item) => {
                const nameSet = new Set(["01"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
        },
        {
            key: "denyThenBucketRateLimitCount",
            label: this.$t("wafrules.denyThenBucketRateLimitCount"),
            formRender: "FormInputNumber",
            inputMinNum: 0,
            defaultVal: 0,
            vShowFieldVal: (item) => {
                const isDenyThenBucket = item.name === "01" && item.denyThenBucket;
                return isDenyThenBucket ? 1 : 0;
            },
            validate: [
                {
                    validator: (rule, value, callback, source, options) => {
                        if (!value) return callback(new Error(vm.$i18n.t("rcmtable.validNumberError")));
                        callback();
                    },
                    trigger: "blur",
                },
            ],
        },
        {
            key: "denyThenBucketRateLimitWindow",
            label: this.$t("wafrules.denyThenBucketRateLimitWindow"),
            formRender: "FormInputNumber",
            inputMinNum: 0,
            defaultVal: 0,
            vShowFieldVal: (item) => {
                const isDenyThenBucket = item.name === "01" && item.denyThenBucket;
                return isDenyThenBucket ? 1 : 0;
            },
            validate: [
                {
                    validator: (rule, value, callback, source, options) => {
                        if (!value) return callback(new Error(vm.$i18n.t("rcmtable.validNumberError")));
                        callback();
                    },
                    trigger: "blur",
                },
            ],
        },
        {
            key: "bucketTime",
            label: this.$t("wafrules.wafBucketTime"),
            formRender: "FormInputNumber",
            inputMinNum: 5,
            inputMaxNum: 43200,
            defaultVal: 300,
            vShowFieldVal: (item) => {
                const isDenyThenBucket = item.name === "01" && item.denyThenBucket;
                const isBlockPeriod = item.name === "08";
                return isDenyThenBucket || isBlockPeriod ? 1 : 0;
            },
            validate: [
                {
                    validator: (rule, value, callback, source, options) => {
                        if (!value) return callback(new Error(vm.$i18n.t("rcmtable.validNumberError")));
                        callback();
                    },
                    trigger: "blur",
                },
            ],
        },
        {
            key: "bucketPreSslDeny",
            label: this.$t("wafrules.wafBucketPreSslDeny"),
            formRender: "FormSwitch",
            watchField: function (item) {},
            vShowFieldVal: (item) => {
                const isDenyThenBucket = item.name === "01" && item.denyThenBucket;
                const isBlockPeriod = item.name === "08";
                return isDenyThenBucket || isBlockPeriod ? 1 : 0;
            },
        },
        {
            key: "bucketPreSslDenyThreshold",
            label: this.$t("wafrules.wafBucketPreSslDenyThreshold"),
            formRender: "FormInputNumber",
            inputMinNum: 0,
            defaultVal: 0,
            vShowFieldVal: (item) => {
                const isDenyThenBucket = item.name === "01" && item.denyThenBucket;
                const isBlockPeriod = item.name === "08";
                return isDenyThenBucket || isBlockPeriod ? 1 : 0;
            },
            validate: [
                {
                    validator: (rule, value, callback, source, options) => {
                        if (!value) return callback(new Error(vm.$i18n.t("rcmtable.validNumberError")));
                        callback();
                    },
                    trigger: "blur",
                },
            ],
        },
        {
            key: "globalBucketRecord",
            label: this.$t("wafrules.wafIsGlobalBucketRecord"),
            formRender: "FormSwitch",
            watchField: function (item) {},
            vShowFieldVal: (item) => {
                const isDenyThenBucket = item.name === "01" && item.denyThenBucket;
                const isBlockPeriod = item.name === "08";
                return isDenyThenBucket || isBlockPeriod ? 1 : 0;
            },
        },
        {
            key: "withL3BucketList",
            label: this.$t("wafrules.wafWithL3BucketList"),
            formRender: "FormSwitch",
            watchField: function (item) {},
            vShowFieldVal: (item) => {
                const isDenyThenBucket = item.name === "01" && item.denyThenBucket;
                const isBlockPeriod = item.name === "08";
                return isDenyThenBucket || isBlockPeriod ? 1 : 0;
            },
        },
        {
            key: "speedLimit",
            label: this.$t("wafrules.wafSpeedLimit"),
            formRender: "FormInputNumber",
            inputMinNum: 1,
            defaultVal: 43200,
            vShowFieldVal: (item) => {
                const nameSet = new Set(["05"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            validate: [
                {
                    validator: (rule, value, callback, source, options) => {
                        if (!value) return callback(new Error(vm.$i18n.t("rcmtable.validNumberError")));
                        callback();
                    },
                    trigger: "blur",
                },
            ],
        },
        {
            key: "redirectUrl",
            label: this.$t("wafrules.wafRedirectUrl"),
            formRender: "WafRedirectUrlBuilder",
            defaultVal: {},
            vShowFieldVal: (item) => {
                const nameSet = new Set(["06"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            extraProps: {
                modalTitle: this.$t(`wafrules.editWafRedirectUrlModalTitle`),
            },
            validate: [
                {
                    required: true,
                    validator: (rule, value, callback) => {
                        if (!value || Object.keys(value).length === 0) {
                            callback(new Error(vm.$t("rcmtable.required")));
                        }
                        callback();
                    },
                    trigger: "change",
                },
            ],
        },
        {
            key: "redirectHttpCode",
            label: this.$t("domainsetting.redirectHttpCode"),
            formRender: "FormSelect",
            defaultVal: 302,
            remoteOptions: async (queryValue, queryParams) => {
                const params = {
                    ...queryParams,
                    groupName: vm.groupName,
                    codeName: `*${queryValue}*`,
                };
                const queryString = new URLSearchParams(params).toString();
                const result = await getFormOptions(`redirect-http-code?${queryString}`);
                const options = result.data.options.map(Number);
                return options;
            },
            vShowFieldVal: (item) => {
                const nameSet = new Set(["06"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
        },
        {
            key: "setReqHeaders",
            label: this.$t("wafrules.wafSetReqHeaders"),
            formRender: "WafSegmentBuilder",
            defaultVal: [],
            vShowFieldVal: (item) => {
                const nameSet = new Set(["09"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
            extraProps: {
                mode: "multiple",
                targetFields: ["key", "value"],
                modalTitle: this.$t(`wafrules.editWafHeadersModalTitle`),
                targetFieldsRule: {
                    key: {
                        literal: [
                            {
                                validator: (rule, value, callback) => {
                                    if (enumList.WAF_SET_REQ_HEADERS_PROHIBITED_KEYS.includes(value.toLowerCase()))
                                        return callback(
                                            new Error(`${vm.$t("rcmtable.systemReservedKeyError")}: ${value}`)
                                        );
                                    callback();
                                },
                                trigger: "change",
                            },
                        ],
                    },
                },
            },
        },
        {
            key: "setResHeaders",
            label: this.$t("wafrules.wafSetResHeaders"),
            formRender: "WafSegmentBuilder",
            defaultVal: [],
            vShowFieldVal: (item) => {
                const nameSet = new Set(["10"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            validate: [
                {
                    required: true,
                    type: "array",
                    min: 1,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
            extraProps: {
                mode: "multiple",
                targetFields: ["key", "value"],
                modalTitle: this.$t(`wafrules.editWafSetResHeadersModalTitle`),
                targetFieldsRule: {
                    key: {
                        literal: [
                            {
                                validator: (rule, value, callback) => {
                                    if (enumList.WAF_SET_REQ_HEADERS_PROHIBITED_KEYS.includes(value.toLowerCase()))
                                        return callback(
                                            new Error(`${vm.$t("rcmtable.systemReservedKeyError")}: ${value}`)
                                        );
                                    callback();
                                },
                                trigger: "change",
                            },
                        ],
                    },
                },
            },
        },
        {
            key: "customHtmlPageName",
            label: this.$t("wafrules.wafCustomHtmlPageName"),
            formRender: "FormSelect",
            defaultVal: "",
            remoteOptions: async (queryValue, queryParams) => {
                const params = {
                    ...queryParams,
                    groupName: vm.groupName,
                    htmlPageName: `*${queryValue}*`,
                    withDefault: false,
                };
                const queryString = new URLSearchParams(params).toString();
                const result = await getFormOptions(`htmlpagenames?${queryString}`);
                return result.data.options;
            },
            vShowFieldVal: (item) => {
                const nameSet = new Set(["12"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            validate: [
                {
                    required: true,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
        },
        {
            key: "originPolicyName",
            label: this.$t("wafrules.wafOriginPolicyName"),
            formRender: "FormSelect",
            defaultVal: "",
            remoteOptions: async (queryValue, queryParams) => {
                const params = {
                    ...queryParams,
                    groupName: vm.groupName,
                    originPolicyName: `*${queryValue}*`,
                };
                const queryString = new URLSearchParams(params).toString();
                const result = await getFormOptions(`originpolicynames?${queryString}`);
                return result.data.options;
            },
            vShowFieldVal: (item) => {
                const nameSet = new Set(["13"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            validate: [
                {
                    required: true,
                    message: vm.$t("rcmtable.required"),
                    trigger: "change",
                },
            ],
        },
        {
            key: "hotlinkSecretKey",
            label: this.$t("wafrules.wafHotlinkSecretKey"),
            formRender: "FormInput",
            defaultVal: "",
            vShowFieldVal: (item) => {
                const nameSet = new Set(["16"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            validate: [{ required: true, message: vm.$t("rcmtable.validateEmptyText"), trigger: "blur" }],
        },
        {
            key: "hotlinkTimeToLive",
            label: this.$t("wafrules.wafHotlinkTimeToLive"),
            formRender: "FormInputNumber",
            inputMinNum: 60,
            inputMaxNum: 60 * 60 * 24,
            defaultVal: 60,
            vShowFieldVal: (item) => {
                const nameSet = new Set(["16"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            validate: [
                {
                    validator: (rule, value, callback, source, options) => {
                        if (!value) return callback(new Error(vm.$i18n.t("rcmtable.validNumberError")));
                        callback();
                    },
                    trigger: "blur",
                },
            ],
        },
        {
            key: "hotlinkQueryArgument",
            label: this.$t("wafrules.wafHotlinkQueryArgument"),
            formRender: "FormInput",
            defaultVal: "",
            vShowFieldVal: (item) => {
                const nameSet = new Set(["16"]);
                return nameSet.has(item.name) ? 1 : 0;
            },
            validate: [{ required: true, message: vm.$t("rcmtable.validateEmptyText"), trigger: "blur" }],
        },
    ];
}



// WEBPACK FOOTER //
// ./src/components/FormItems/wafRuleList/ruleFields.js